module.exports = __webpack_public_path__ + "static/media/1_6.8c8b4be0.png";